import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";

const PainelParceiro = lazy(() => import("../app-views/painel-parceiro"));

export const ParceiroViews = () => {
	useEffect(() => {
		if (JwtAuthService.isLogged()) {
			MenuService.populateMenuData().catch(() => {});
		}
	}, []);

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${APP_PREFIX_PATH}/painel-parceiro`}
					component={PainelParceiro}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/painel-parceiro`}
				/>
			</Switch>
		</Suspense>
	);
};

export default ParceiroViews;
